import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { Observable, of, timer } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { PromocionesService } from './services/promociones.service';

export function ValidatorAsyncCheckPromocion(promocionService: PromocionesService): AsyncValidatorFn {
  return (abstractControl: AbstractControl): Observable<ValidationErrors | null> => {
    return timer(1000)
      .pipe(
        switchMap(() => {
          const id = abstractControl.value;
          return promocionService.buscarPromo(id)
            .pipe(
              map((res) => res ? {existePromocion: true} : null),
              catchError(() => of(null))
            )
        })
      );
  }
}